<template>
  <div class="w-full flex-y-center" :class="{ 'edit-hover-show': isHover }">
    <a-input
      ref="inputRef"
      v-model:value="inputValue"
      type="text"
      :allowClear="allowClear"
      :size="size"
      :spellCheck="false"
      @change="handleChange"
      @keyup.enter="() => {}"
    >
      <template #suffix>
        <span class="text-[12px] text-font-40 font-normal">
          {{ textLength }} / {{ maxlength }}
        </span>
      </template>
    </a-input>
  </div>
</template>
<script lang="ts" name="EditableLabel" setup>
const props = withDefaults(
  defineProps<{
    value: string
    size?: 'large' | 'middle' | 'small'
    maxlength?: number
    isHover?: boolean
    regex?: RegExp
    allowClear?: boolean
  }>(),
  {
    label: '',
    value: '',
    size: 'middle',
    maxlength: 16,
    allowClear: false,
    isHover: true,
  }
)
const emit = defineEmits(['update:value', 'change'])

const inputRef = ref()
const inputValue = ref(props.value)

// const getStringLength = (str: string): number => {
//   let len = 0
//   const chineseRegex = /[\u4E00-\u9FA5]/g
//   const chinese = str?.match(chineseRegex)
//   if (chinese) {
//     len += chinese.length * 2
//   }
//   return str?.length - (chinese?.length ?? 0) + len
// }

const textLength = computed(() => {
  // const len = getStringLength(inputValue.value)
  const len = inputValue.value?.length || 0
  return len > props.maxlength ? props.maxlength : len
})

watch(
  () => props.value,
  (cur, before) => {
    if (cur !== before) {
      inputValue.value = cur
    }
  }
)

const sliceText = (text: string) => {
  let length = 0
  let result = ''
  for (let i = 0; i < text.length; i++) {
    const char = text[i]
    // const tempLen = getStringLength(char)
    const tempLen = char?.length || 0
    if (length + tempLen <= props.maxlength) {
      result += char
      length += tempLen
    } else {
      break
    }
  }
  return result
}

const handleChange = (e: any) => {
  const text = e.target?.value
  inputValue.value = sliceText(text)
  emit('update:value', inputValue.value)
}
</script>
<style lang="scss" scoped>
.label {
  @apply block truncate text-14 font-medium text-font-80;
}

.edit-hover-show {
  .edit-icon {
    visibility: hidden;
  }
  &:hover {
    .edit-icon {
      visibility: visible;
    }
  }
}

:deep(.ant-input-show-count-suffix) {
  font-size: 12px;
}
</style>
